export default __webpack_public_path__ + "000a4cdfeaa92d7fc46e2480ab4f7af6.png";